<template>
  <div>
    <div
      class="tw:flex tw:flex-col tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:px-[30px] tw:py-11 tw:lg:px-0 tw:mx-auto"
    >
      <h1
        class="tw:landing:hidden tw:text-2xl tw:font-bold tw:mb-6 tw:md:mb-8 tw:text-center tw:sm:text-left tw:w-full"
      >
        {{ $t('rc_smartboost_benefit_header') }}
      </h1>

      <div class="tw:flex tw:flex-col tw:md:flex-row tw:items-center tw:justify-between tw:w-full tw:gap-x-8">
        <div class="tw:flex tw:flex-col tw:w-full tw:lg:w-1/2">
          <h1 class="tw:hidden tw:landing:block tw:text-2xl tw:font-bold tw:mb-6 tw:md:mb-4 tw:text-left">
            {{ $t('rc_smartboost_benefit_header') }}
          </h1>

          <ul class="tw:gap-y-1 tw:flex tw:flex-col">
            <li v-for="point in list" :key="point" class="tw:flex tw:items-baseline tw:gap-x-2">
              <CheckPointIcon />
              {{ $t(point) }}
            </li>
          </ul>
          <div class="tw:mt-6 tw:mb-8 tw:md:mb-0 tw:mx-auto tw:md:ml-0">
            <SecondaryButton
              class="icon-btn tw:flex tw:gap-x-2 tw:justify-center tw:items-center tw:mb-2 tw:sm:mb-0"
              @click="openVideo"
              data-testid="smart-boost-video-cta-button"
            >
              <PlayIcon class="tw:fill-white tw:mr-2" />
              {{ $t('rc_smartboost_video_cta') }}
            </SecondaryButton>
          </div>
        </div>
        <div class="tw:w-full tw:lg:w-1/2 tw:flex tw:justify-center">
          <picture>
            <source media="(min-width: 768px)" :srcset="getSmartBoostImage('m')" />
            <img :src="getSmartBoostImage('s')" :alt="$t('rc_smartboost_tab')" />
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import SecondaryButton from '@/components/base/buttons/SecondaryButton.vue'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'
import CheckPointIcon from '@/components/icons/CheckPointIcon.svg?component'
import { useSessionValues } from '@/composables/useSessionValues'

const emit = defineEmits(['openVideo'])
const openVideo = () => emit('openVideo')
const list = ['rc_smartboost_benefit_1', 'rc_smartboost_benefit_2', 'rc_smartboost_benefit_3']

const smartBoostImages = import.meta.glob('/src/assets/img/smart-boost/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
})

const { language } = useSessionValues()
const currentLocation = computed(() => {
  const parts = language.value.split('-')
  return (parts[1] || 'us').toLowerCase()
})

const getSmartBoostImage = size => {
  const path = `/src/assets/img/smart-boost/smartBoost_${size}_${currentLocation.value}.svg`
  return smartBoostImages[path] || smartBoostImages[`/src/assets/img/smart-boost/smartBoost_${size}_us.svg`] || ''
}
</script>
